import api from '@/api/customer'

const state = {
    item: null,
    items: [],
    pagination: null,
    customerUser: null,
}

const getters = {
    customers(state) {
        return state.items || []
    },

    customer(state) {
        return state.item || null
    },

    customerUsers(state) {
        const users = ((state.item || {}).users || []).map(x => x.user)
        return users
    },
}

const mutations = {
    SET_CUSTOMER(state, payload) {
        state.item = payload
    },
    SET_CUSTOMERS(state, payload) {
        state.items = payload
    },
    DELETE_CUSTOMER(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
        console.log('deleted item at index ' + index)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
}

const actions = {
    async create(context, payload) {
        const res = await api.create(payload) //.then(() => {})
        console.log('customer create', res.data.success.data)
        context.commit('SET_CUSTOMER', res.data.success.data)
    },
    async uploadCustomer({ commit, state }, payload) {
        const result = await api
            .upload(payload)
            .then(response => response)
            .catch(error => error.response)

        let success = result.data.success
        let { data } = success == undefined ? {} : success
        if (!data) return result.data.success || result.data.error

        const customers = [...state.items]
        const idx = customers.findIndex(x => x.id === data.id)
        customers.splice(idx === -1 ? customers.length : idx, 1, data)
        commit('SET_CUSTOMERS', customers)

        return result.data.success
    },
    fetch(context, params) {
        let { query, page: pg } = params || {}
        query = query || ''
        pg = pg || 1
        return api
            .fetch(query, pg)
            .then(result => {
                let {
                    data,
                    current_page: page,
                    per_page: pageSize,
                    total,
                } = result.data.success.data
                console.log('customers search---', data)
                context.commit('SET_CUSTOMERS', data)
                context.commit('set_pagination', {
                    page,
                    pageSize,
                    total,
                })
            })
            .catch(err => {
                throw err
            })
    },
    fetchById(context, id) {
        console.log('id', id)
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data: item },
                    },
                }) => {
                    console.log('assumed customer', item)
                    context.commit('SET_CUSTOMER', item)
                }
            )
            .catch(err => {
                throw err
            })
    },
    update(context, payload) {
        return api
            .update(payload.id, payload)
            .then(() => {})
            .catch(err => {
                throw err
            })
    },
    delete(context, id) {
        console.log('deleting')
        return api
            .delete(id)
            .then(() => {
                context.commit('DELETE_CUSTOMER', id)
            })
            .catch(err => {
                throw err
            })
    },
    //////////////////////////////////////customer users//////////////////
    async createUser(context, { customer_id, data }) {
        console.log('customer create---', { customer_id, data })
        await api.createUser(customer_id, data)
        await context.dispatch('fetchById', customer_id)
    },

    async updateUser(context, { customer_id, data }) {
        const userData = { ...data }
        const user_id = data.id
        delete userData.id
        await api.updateUser(customer_id, user_id, userData)
        await context.dispatch('fetchById', customer_id)
    },
    async deleteUser(context, { customer_id, user_id }) {
        await api.deleteUser(customer_id, user_id)
        await context.dispatch('fetchById', customer_id)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
